"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableFilter = void 0;
const config_service_1 = require("../../../shared/config/config.service");
const getTableFilter = (configService, customerModel, usersService) => ({
    seriesOptions: {
        traversal: 'vehicleData.features.seriesOptions',
        type: 'ARRAY_OBJECT',
        objectKey: 'code',
    },
    additionalOptions: {
        traversal: 'vehicleData.features.additionalOptions',
        type: 'ARRAY_OBJECT',
        objectKey: 'code',
    },
    make: {
        traversal: 'modelData.make',
    },
    model: {
        traversal: 'modelData.model',
    },
    vin: {
        traversal: ['vin', '_id'],
    },
    modelDescription: {
        traversal: 'modelData.modelDescription',
    },
    state: {
        traversal: 'vehicleData.availability.state',
        translations: configService.get('sales_car_types'),
    },
    location: {
        traversal: 'vehicleData.inventory.location',
        translations: configService.get('general_locations'),
    },
    transmission: {
        traversal: 'modelData.engine.transmission.type',
        translations: configService.getConstant(config_service_1.ConstantTypes.TRANSMISSION_TYPES),
    },
    drivetrain: {
        traversal: 'modelData.engine.drivetrain',
        translations: configService.getConstant(config_service_1.ConstantTypes.DRIVETRAIN_TYPES),
    },
    fuel: {
        traversal: 'modelData.engine.fuel.type',
        translations: configService.getConstant(config_service_1.ConstantTypes.FUEL_TYPES),
        quote: true,
    },
    customer: {
        traversal: ['vehicleData.availability.sellData.customerId', 'vehicleData.availability.reservationData.customerId'],
        translationFunction: (filterValue) => customerModel.getName(filterValue),
    },
    customerLegacy: {
        traversal: ['vehicleData.availability.sellData.customer', 'vehicleData.availability.reservationData.customer'],
    },
    seller: {
        traversal: ['vehicleData.availability.sellData.seller', 'vehicleData.availability.reservationData.seller'],
        translations: usersService.getUsersForFilter(),
        type: 'NUMBER',
    },
    bodycode: {
        traversal: 'bodycode',
    },
    orderNumber: {
        traversal: 'vehicleData.order.orderNumber',
    },
    availability: {
        traversal: 'vehicleData.availability.code',
        translations: configService.getConstant(config_service_1.ConstantTypes.AVAILABILITY),
    },
    license: {
        traversal: 'vehicleData.registration.licence',
    },
    modelyear: {
        traversal: 'modelData.modelyear',
        type: 'NUMBER',
    },
    inventory: {
        traversal: 'vehicleData.inventory.state',
        translations: configService.getConstant(config_service_1.ConstantTypes.INVENTORY_STATE),
    },
    colorOuter: {
        traversal: ['vehicleData.features.exteriorColor.manufacturerCode', 'vehicleData.features.exteriorColor.manufacturerName'],
    },
    colorOuterSelection: {
        translations: configService.getConstant(config_service_1.ConstantTypes.EXTERIOR_COLOR_NAME),
        traversal: 'vehicleData.features.exteriorColor.color',
    },
    colorInner: {
        traversal: ['vehicleData.features.interiorColor.manufacturerCode', 'vehicleData.features.interiorColor.manufacturerName'],
    },
    colorInnerSelection: {
        traversal: 'vehicleData.features.interiorColor.color',
        translations: configService.getConstant(config_service_1.ConstantTypes.INTERIOR_COLOR_NAME),
    },
    online: {
        traversal: 'apiData',
        translations: {
            'AutoScout24.de': 'AutoScout24.de',
            Händlerwebsite: 'Händlerwebsite',
            'mobile.de': 'mobile.de',
            Nicht: 'Nicht online beworben',
        },
        fullTraversals: {
            'mobile.de': `{
        "$and": [
          { "apiData.MOBILE_SELLER": { "$exists": true } },
          { "apiData.MOBILE_SELLER": { "$ne": null } },
          { "apiData.MOBILE_SELLER": { "$ne": false } }
        ]
      }`,
            'AutoScout24.de': `{
        "$and": [
          { "apiData.AUTOSCOUT24": { "$exists": true } },
          { "apiData.AUTOSCOUT24": { "$ne": null } },
          { "apiData.AUTOSCOUT24": { "$ne": false } }
        ]
      }`,
            Händlerwebsite: `{
        "$and": [
          { "apiData.AWI": { "$exists": true } },
          { "apiData.AWI": { "$ne": null } },
          { "apiData.AWI": { "$ne": false } }
        ]
      }`,
            Nicht: `{
        "$and": [
          {
            "$or": [
              { "apiData.MOBILE_SELLER": { "$exists": false } },
              { "apiData.MOBILE_SELLER": { "$eq": null } },
              { "apiData.MOBILE_SELLER": false }
            ]
          },
          {
            "$or": [
              { "apiData.AUTOSCOUT24": { "$exists": false } },
              { "apiData.AUTOSCOUT24": { "$eq": null } },
              { "apiData.AUTOSCOUT24": false }
            ]
          },
          {
            "$or": [
              { "apiData.AWI": { "$exists": false } },
              { "apiData.AWI": { "$eq": null } },
              { "apiData.AWI": false }
            ]
          }
        ]
      }`,
        },
    },
    dataCheck: {
        traversal: 'dataCheck',
        translations: { NOT_DEFINED: 'Hat kein Datencheck', DEFINED: 'Hat Datencheck' },
    },
    pkwEnvkReady: {
        traversal: 'pkwEnvkReady',
        translations: { NOT_DEFINED: 'Pkw-EnVKV unzulässig', DEFINED: 'Pkw-EnVKV konform' },
    },
    infotainment: {
        traversal: 'modelData.infotainment',
        type: 'BOOLEAN_OBJECT',
        translations: {
            androidAuto: 'Android Auto',
            appleCarplay: 'Apple CarPlay',
            betterSound: 'Besseres Soundsystem',
            bluetooth: 'Bluetooth',
            boardComputer: 'Boardcomputer',
            cd: 'CD',
            digitalDashboard: 'Digitaler Tachograph',
            handsFreePhoneSystem: 'Freisprecheinrichtung',
            wirelessCharging: 'Kabelloses Laden für Smartphones',
            multifunctionSteeringWheel: 'Multifunktionslenkrad',
            musicStreaming: 'Musikstreamingdienste',
            satNav: 'Navigationssystem',
            voiceControl: 'Sprachassistent',
            touchscreen: 'Touchscreen',
            tv: 'TV',
            usb: 'USB',
            wifi: 'Wi-Fi',
        },
    },
    assistance: {
        traversal: 'modelData.assistance',
        type: 'BOOLEAN_OBJECT',
        translations: {
            lightSensor: 'Automatisches Abblendlicht',
            hillAssist: 'Berganfahrassistent',
            automaticHighBeam: 'Fernlichtassistent',
            speedLimiter: 'Geschwindigkeitslimit-Assistent',
            emergencyCall: 'Notrufsystem',
            rainSensor: 'Regensensor',
            tirePressureMonitoring: 'Reifendruckkontrollsystem',
            powerSteeting: 'Servolenkung',
            laneAssistance: 'Spurhalteassistent',
            startStop: 'Start-Stopp-System',
            blindSpot: 'Totwinkel-Assistent',
            signRecognition: 'Verkehrszeichenerkennung',
        },
    },
    comfort: {
        traversal: 'modelData.comfort',
        type: 'BOOLEAN_OBJECT',
        translations: {
            ambientLighting: 'Ambientebeleuchtung',
            armRest: 'Armlehne',
            heatedSteeringWheel: 'Beheizbares Lenkrad',
            heatedRearSeats: 'Beheizbare Rücksitze',
            heatedFrontSeats: 'Beheizbare Vordersitze',
            heatedWindshield: 'Beheizbare Windschutzscheibe',
            electricSideMirrors: 'Elektrische Außenspiegel',
            electricWindows: 'Elektrische Fensterheber',
            electricTailgate: 'Elektrische Heckklappe',
            electricRearSeats: 'Elektrisch verstellbare Rücksitze',
            electricFrontSeats: 'Elektrisch verstellbare Vordersitze',
            bootDivider: 'Gepäckraumabtrennung',
            headUpDisplay: 'Head-up-Display',
            keylessEntry: 'Keyless-Entry',
            leatherSteeringWheel: 'Lederlenkrad',
            lumbarSupport: 'Lendenwirbelstütze',
            airSuspension: 'Luftfahrwerk',
            massageSeats: 'Massagesitze',
            panoramicRoof: 'Panoramadach',
            sunroof: 'Schiebedach',
            ventilatedFrontSeats: 'Sitzlüftung',
            foldPassengerSeat: 'Umklappbarer Beifahrersitz',
            centralLocking: 'Zentralverriegelung',
        },
    },
    general: {
        traversal: 'modelData.features',
        type: 'BOOLEAN_OBJECT',
        translations: {
            allowWheels: 'Alufelgen',
            roofRails: 'Dachreling',
            auxHeating: 'Standheizung',
            summerTires: 'Sommerreifen',
            winterTires: 'Winterreifen',
            allSeasonTires: 'Ganzjahresreifen',
            steelWheels: 'Stahlfelgen',
            skibag: 'Skitasche',
        },
    },
    safety: {
        traversal: 'modelData.safety',
        type: 'BOOLEAN_OBJECT',
        translations: {
            headlightWasher: 'Scheinwerferreinigungsanlage',
            abs: 'ABS',
            esp: 'ESP',
            alarm: 'Alarmanlage',
            distanceWarning: 'Auffahrwarnsystem',
            fatigueWarning: 'Aufmerksamkeits-Assistent',
            dimmingMirror: 'Automatisch abblendende Spiegel',
            glareFreeHighBeam: 'Blendfreies Fernlicht',
            immobilizer: 'Elektronische Wegfahrsperre',
            isofixPassenger: 'Isofix-Halterungen Beifahrersitz',
            isofixBack: 'Isofix-Halterungen Rücksitze',
            nightVision: 'Nachtsicht-Assistent',
            frontFogLights: 'Nebelscheinwerfer',
            collisionAvoidance: 'Notbremsassistent',
        },
    },
    sport: {
        traversal: 'modelData.sport',
        type: 'BOOLEAN_OBJECT',
        translations: {
            performanceHandling: 'Sportfahrwerk',
            seats: 'Sportsitze',
            paddleShifters: 'Schaltwippen',
        },
    },
    productionState: {
        traversal: 'vehicleData.production.productionState',
    },
    standingTimeInvoice: {
        traversal: 'vehicleData.costs.invoiceDate',
        type: 'DAYS_GREATER',
    },
    standingTimeDelivery: {
        traversal: 'vehicleData.inventory.deliveryDate',
        type: 'DAYS_GREATER',
    },
    vehicleImages: {
        traversal: 'vehicleData.images',
        type: 'ARRAY_LENGTH',
        comparator: '$eq',
    },
    previousOwner: {
        traversal: 'vehicleData.previousOwner.previousOwner',
    },
});
exports.getTableFilter = getTableFilter;
